import { faTrashAlt } from '@fortawesome/free-regular-svg-icons/faTrashAlt';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Flex } from '../../Flex';
import { Box } from '../../Box';
import { Button } from '../../Button';
import { WarningField } from '../WarningField';
var ArrayFieldTitle = function (_a) {
    var TitleField = _a.TitleField, idSchema = _a.idSchema, required = _a.required, title = _a.title;
    if (!title) {
        return null;
    }
    var id = idSchema.$id + "__title";
    return React.createElement(TitleField, { id: id, title: title, required: required });
};
var ArrayFieldDescription = function (_a) {
    var DescriptionField = _a.DescriptionField, idSchema = _a.idSchema, description = _a.description;
    if (!description) {
        return null;
    }
    var id = idSchema.$id + "__description";
    return React.createElement(DescriptionField, { id: id, description: description });
};
export default (function (props) {
    var _a, _b;
    var warning = props.uiSchema['ui:warning'];
    var orderable = (_b = (_a = props.uiSchema['ui:options']) === null || _a === void 0 ? void 0 : _a.orderable) !== null && _b !== void 0 ? _b : true;
    return (React.createElement("div", { className: props.uiSchema.classNames },
        React.createElement(ArrayFieldTitle, { TitleField: props.TitleField, idSchema: props.idSchema, title: props.uiSchema['ui:title'] || props.title, required: props.required }),
        !!warning && React.createElement(WarningField, { warning: warning }),
        React.createElement(ArrayFieldDescription, { DescriptionField: props.DescriptionField, idSchema: props.idSchema, description: props.uiSchema['ui:description'] || props.schema.description }),
        props.items.map(function (element) {
            return (React.createElement("div", { className: "rendition-form__array-item", key: element.index },
                React.createElement(Flex, { alignItems: "flex-start" },
                    React.createElement(Box, { flex: "1" }, element.children),
                    React.createElement(Box, null,
                        orderable && props.items.length > 1 && (React.createElement(Button, { type: "button", className: "rendition-form-array-item__move-up", py: 1, px: 2, primary: true, plain: true, disabled: element.disabled || element.readonly || !element.hasMoveUp, onClick: element.onReorderClick(element.index, element.index - 1) },
                            React.createElement(FontAwesomeIcon, { icon: faArrowUp }))),
                        orderable && props.items.length > 1 && (React.createElement(Button, { type: "button", className: "rendition-form-array-item__move-down", py: 1, px: 2, plain: true, primary: true, disabled: element.disabled ||
                                element.readonly ||
                                !element.hasMoveDown, onClick: element.onReorderClick(element.index, element.index + 1) },
                            React.createElement(FontAwesomeIcon, { icon: faArrowDown }))),
                        element.hasRemove && (React.createElement(Button, { type: "button", className: "rendition-form-array-item__remove-item", plain: true, primary: true, py: 1, px: 2, disabled: element.disabled || element.readonly, onClick: element.onDropIndexClick(element.index) },
                            React.createElement(FontAwesomeIcon, { icon: faTrashAlt })))))));
        }),
        props.canAdd && (React.createElement(Button, { mt: 3, type: "button", className: "rendition-form-array-item__add-item", icon: React.createElement(FontAwesomeIcon, { icon: faPlus }), onClick: props.onAddClick }, "Add item"))));
});
